import { Card, Grid, Typography } from "@mui/material"
import { Link } from "react-router-dom"

export const SingleOrder = ({ order }) => {
	// Get date from created_at
	const orderDate = new Date(order.created_at).toLocaleDateString("fi-FI")

	const handleClick = () => {}

	return (
		<Grid item xs={1}>
			<Link to={`/admin/tilaus/${order.orderinfoid}`}>
				<Card elevation={8} sx={{ cursor: "pointer" }} onClick={handleClick}>
					<Typography variant="h3">Tilaus {order.orderinfoid}</Typography>
					<Typography variant="h5">{orderDate}</Typography>
				</Card>
			</Link>
		</Grid>
	)
}
